import { ResizedImage } from '@ah/design/mobile';
import type { ChosenSuperconnector } from '@ah/people/shared';
import { MAIA_PNG } from '../../assets';

export function SuperconnectorAvatar({ godmother, size = 6 }: { godmother: ChosenSuperconnector | null; size?: number }) {
  const pictureUrl = godmother?.pictureUrl ?? MAIA_PNG;
  const alt = godmother?.firstName ?? 'Your Underling';
  const pixelSize = size * 4;
  return (
    <ResizedImage
      src={pictureUrl}
      renderWidth={pixelSize}
      fallback={false}
      alt={alt}
      style={{ width: `${pixelSize}px`, height: `${pixelSize}px` }}
      className="rounded-full object-cover shrink-0"
    />
  );
}
